import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl08 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".white{fill:#fff;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Command_08",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Cross",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "white",
				d: "M41.9,56.15c-.36,0-.69-.19-.87-.5l-9.04-15.65-9.04,15.65c-.18.31-.51.5-.87.5-.18,0-.34-.04-.5-.13l-5.19-3c-.23-.13-.4-.35-.47-.61-.07-.26-.03-.53.1-.76l11.34-19.65-11.34-19.65c-.13-.23-.17-.5-.1-.76.07-.26.24-.47.47-.61l5.2-3c.15-.09.32-.13.5-.13.36,0,.69.19.87.5l9.04,15.65,9.04-15.65c.18-.31.51-.5.87-.5.18,0,.34.04.5.13l5.19,3c.23.13.4.35.47.61.07.26.03.53-.1.76l-11.34,19.65,11.34,19.65c.13.23.17.5.1.76-.07.26-.24.47-.47.61l-5.2,3c-.15.09-.32.13-.5.13h0Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "black",
				d: "M37.77,32l11.06-19.15c.55-.96.22-2.18-.73-2.73l-5.2-3c-.31-.18-.66-.27-1-.27-.69,0-1.36.36-1.73,1l-8.17,14.15-8.17-14.15c-.37-.64-1.04-1-1.73-1-.34,0-.68.09-1,.27l-5.2,3c-.96.55-1.28,1.78-.73,2.73l11.06,19.15-11.06,19.15c-.55.96-.22,2.18.73,2.73l5.2,3c.31.18.66.27,1,.27.69,0,1.36-.36,1.73-1l8.17-14.15,8.17,14.15c.37.64,1.04,1,1.73,1,.34,0,.68-.09,1-.27l5.2-3c.96-.55,1.28-1.78.73-2.73l-11.06-19.15ZM41.9,8.85h0s0,0,0,0h0ZM32,38l-1.73,3-4.17,7.22-5.2-3,7.06-12.22.58-1-.58-1-7.06-12.22,5.2-3,4.17,7.22,1.73,3,1.73-3,4.17-7.22,5.2,3-7.06,12.22-.58,1,.58,1,7.06,12.22-5.2,3-4.17-7.22-1.73-3Z"
			})]
		})
	})]
});
export default SvgAppIcBefehl08;
